import {PdsWidget} from './pds-widget';
export class PdsNumberedSlider extends PdsWidget {
  is = 'pds-numbered-slider';

  value: number;
  max: number;

  properties = {
    min: Number,
    max: {
      type: Number,
      observer: 'maxChanged'
    },
    value: {
      type: Number,
      observer: 'valueChanged'
    },
    name: String  //we construct the input id using this name.
  };

  //Get and Set modelValue are here for Angular2 to interact with.
  set modelValue(value: number) {
    if (typeof value === 'string') {
      value = parseInt(String(value));
    }

    this.value = value;
    this.querySelector('input').value = value;
  }

  get modelValue(): number {
    return this.value;
  }

  //Called by the observer.
  valueChanged(value): void {
    this.querySelector('input').value = this.value;
    this.updateNumber();
  }

  //Called by the observer.
  maxChanged(max): void {
    this.querySelector('input').setAttribute('max', this.max);
    this.updateNumber();
  }

  attributeChanged(name: string, type: any): void {
    if (this.properties.hasOwnProperty(name)) {
      //Push the attributes right down onto the input.
      this.querySelector('input').setAttribute(name, this[name]);
    }
  }

  ready(): void {
    super.ready();
    let input: HTMLElement = this.querySelector('input');
    input.setAttribute('min', (<any>this).getAttribute('min'));
    input.setAttribute('max', (<any>this).getAttribute('max'));
    input.setAttribute('value', this.value || (<any>this).getAttribute('value'));

    let updateValueAndDispatchModelValueChange = function (event): void {
      //Save the finalized input value to the PdsNumberedSlider property
      this.value = parseInt(event.target.value);

      let e: Event = new Event('modelValueChange', { bubbles: true });
      this.dispatchEvent(e);
    };

    //We need the mouseup, touchend, and keyup listeners to deliver changes to whoever is listening.
    input.addEventListener('mouseup', updateValueAndDispatchModelValueChange.bind(this));
    input.addEventListener('touchend', updateValueAndDispatchModelValueChange.bind(this));
    input.addEventListener('keyup', updateValueAndDispatchModelValueChange.bind(this));

    //We need two listeners here to keep track of what the value of the input is because
    //IE, FireFox, and Chrome implement the change events differently.
    input.addEventListener('input', this.updateNumber.bind(this));
    input.addEventListener('change', this.updateNumber.bind(this));
  }

  updateNumber = function (): void {
    let input: HTMLElement = this.querySelector('input');
    let i = 0;
    let currentPage = parseInt((<any>input).value);
    let dotLabel = this.querySelector('span.pds-dot-label');
    let dotBackground = this.querySelector('span.pds-dot-background');
    let max = parseInt(this.max);
    let min = parseInt(this.min);
    let totalPages = max - min;

    let offset = 32 * (currentPage - min) / totalPages;
    let position = 100 * (currentPage - min) / totalPages;

    let positionStyle = 'calc(' + position + '% - ' + offset + 'px)';

    //May no one ever have to debug through this awful piece of code. The designers made me do it.
    dotBackground.style.left = positionStyle;
    dotLabel.style.left = positionStyle;
    dotLabel.innerText = currentPage;
  };
}
